import styled from '@emotion/styled';

export const GridContainer = styled.span`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 0 1rem;
  align-items: start;
  font-size: var(--font-size-basis);
`;

export const GridLabel = styled.span`
  font-weight: var(--font-weight-medium);
`;

export const GridValue = styled.span`
  word-wrap: break-word;
  white-space: pre-wrap;
`;

export const UnselectableLabelStyle = styled.i`
  color: grey;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
